import React, { useState, memo } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/contexts/auth";

import NavbarLogo from "./NavbarLogo";
import NavbarMenu from "./NavbarMenu";
import RoleSelector from "./RoleSelector";
import UserMenu from "./UserMenu";
import LoginButton from "./LoginButton";
import MobileMenu from "./MobileMenu";
import LanguageSelector from "./LanguageSelector";
import SwitchBackButton from "./SwitchBackButton";
import ThemeToggle from "./ThemeToggle";

const Navbar: React.FC = memo(() => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-background border-b border-border py-3 md:py-1 px-4 md:px-6">
      <div className="container mx-auto flex items-center justify-between">
        <NavbarLogo />

        <div className="flex items-center space-x-3 md:hidden">
          {user && <SwitchBackButton />}
          <button className="text-foreground" onClick={toggleMenu} aria-label="Otevřít menu">
            {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>

          {/* Mobile avatar - clickable with UserMenu */}
          {user && (
            <div className="relative">
              <UserMenu />
            </div>
          )}
        </div>

        <div className="hidden md:flex items-center space-x-3">
          <NavbarMenu />

          {user ? (
            <div className="flex items-center space-x-2">
              <SwitchBackButton />
              <ThemeToggle />
              <LanguageSelector />
              <RoleSelector />
              <UserMenu />
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <ThemeToggle />
              <LanguageSelector />
              <LoginButton />
            </div>
          )}
        </div>

        <MobileMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </div>
    </nav>
  );
});

Navbar.displayName = "Navbar";

export default Navbar;
